import { OptionItemInterface, ValidationResultInterface } from '../../types/interfaces'
import classes from './SearchGroupSelect.module.sass'
import { useSearchGroupSelect } from './hooks/useSearchGroupSelect'
import close from '../../../assets/images/icons/close.svg'
import { shortenText } from '../../utils/functions/shortenText'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'

type Props = {
  label?: string
  options: OptionItemInterface[]
  value: number[]
  onChangeHandler: (value: string | number | boolean, fieldName: string, type: string) => void
  onRemoveHandler: (value: string | number | boolean, fieldName: string) => void
  fieldName: string
  type: string
  onBlur?: (fieldName: string) => void
  itemValidationResult?: ValidationResultInterface
  disabled?: boolean
  placeholder: string
  keySelectField?: string
}

export const SearchGroupSelect = ({
  label,
  options,
  value,
  onChangeHandler,
  fieldName,
  type,
  onBlur,
  itemValidationResult,
  disabled,
  placeholder,
  onRemoveHandler,
}: Props) => {
  const {
    filteredList,
    searchString,
    setSearchString,
    expanded,
    setExpanded,
    onBlurAction,
    setFocusedIndex,
    handleKeyDown,
    selectedExpanded,
    setSelectedExpanded,
  } = useSearchGroupSelect(options, onChangeHandler, fieldName, type, value)

  const dark = useSelector(selectDarkTheme)

  return (
    <div className={classes.SelectContainer}>
      {label && <label className={classes.Label}>{label}</label>}

      <input
        disabled={disabled}
        value={searchString}
        type="text"
        placeholder={placeholder}
        onFocus={() => {
          onChangeHandler('', fieldName, type)
          setSearchString('')
          setSelectedExpanded(false)
          setExpanded(true)
        }}
        onBlur={() => {
          onBlur && onBlur(fieldName)
          onBlurAction()
        }}
        className={
          itemValidationResult?.isEmptyError && dark
            ? classes.ContainerRequiredDark
            : itemValidationResult?.isEmptyError
              ? classes.ContainerRequired
              : dark
                ? classes.ContainerDark
                : classes.Container
        }
        onChange={(e) => setSearchString(e.target.value)}
        onClick={() => {
          setFocusedIndex(0)
        }}
        onKeyDown={(e) => {
          handleKeyDown(0, e)
        }}
      />

      {expanded && filteredList.length > 0 && (
        <div className={dark ? classes.OptionsContainerDark : classes.OptionsContainer}>
          {filteredList.map((el, index) => (
            <div
              key={el.id}
              className={classes.Option}
              onClick={() => {
                setSearchString('')
                el.value && onChangeHandler(el.value, fieldName, type)
              }}
              onKeyDown={(e) => handleKeyDown(index + 1, e)}
              tabIndex={-1}
            >
              {el.label}
            </div>
          ))}
        </div>
      )}

      {value && value.length > 0 && (
        <div className={classes.SelectedValuesWrapper}>
          <div className={classes.SelectedValues}>
            {value.slice(0, selectedExpanded ? value.length : 3).map((el) => {
              const option = options.find((item) => Number(item.value) === el)
              return (
                <div key={el} className={dark ? classes.SelectedValueDark : classes.SelectedValue}>
                  <span>{shortenText(option?.label || '', selectedExpanded ? 100 : 20)}</span>
                  <img
                    src={close}
                    className={classes.CloseIcon}
                    alt="Удалить"
                    onClick={() => onRemoveHandler(el, fieldName)}
                  />
                </div>
              )
            })}
            {!selectedExpanded && value.length > 3 && (
              <div className={classes.MoreButton} onClick={() => setSelectedExpanded(true)}>
                и еще {value.length - 3}
              </div>
            )}
          </div>
        </div>
      )}

      <div className={classes.ValidationErrorField}>
        {itemValidationResult?.isDirty &&
          itemValidationResult.notValid &&
          itemValidationResult?.errorMessage}
      </div>
    </div>
  )
}
